module.exports = __webpack_public_path__ + "img/sound-3-image.de3776e0.jpg";